import React, { useRef } from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { Container, Stack } from '@fiverr-private/layout_components';
import withContext from '../../../lib/withContext';
import { Nav, NavItem, Layout, NavDivider, JoinLink, Logo, NavIcon } from '../../blocks';
import { Search, LoginLink, LeanLocaleSettingsLink, FiverrProNavigation, ExploreNavigation } from '../../components';
import { GuestBecomeSellerNavItem } from '../../components/GuestBecomeSellerNavItem';
import { useStickyTriggers } from '../../hooks/useStickyTriggers';
import { localeNavWrapper } from '../LoggedOut/LoggedOutLocaleNavItem.ve.css';
import { LEGACY_SEARCH_BAR_PACKAGE_SELECTOR } from './constants';

export const LoggedOutHomepage = () => {
    const headerRef = useRef<HTMLDivElement>(null);

    const { showSearch } = useStickyTriggers({
        headerRef,
        selectors: {
            showSearch: LEGACY_SEARCH_BAR_PACKAGE_SELECTOR,
        },
    });

    return (
        <Layout ref={headerRef}>
            <Container
                hidden={{
                    default: false,
                    lg: true,
                }}
            >
                <NavIcon />
            </Container>
            <Stack hidden={{ default: showSearch, sm: false }} marginRight={{ default: '0', sm: 'auto' }}>
                <Logo href={pathfinder('root', {}, { query: { source: 'top_nav' } })} />
            </Stack>
            <Container width="100%" display="block" hidden={{ default: !showSearch, md: false }}>
                <Search show={showSearch} showOnMobile fullWidth />
            </Container>
            <Nav gap="2">
                <NavItem displayFrom="lg">
                    <FiverrProNavigation />
                </NavItem>
                <NavItem displayFrom="lg">
                    <ExploreNavigation />
                </NavItem>
                <NavItem displayFrom="md">
                    <Container className={localeNavWrapper}>
                        <LeanLocaleSettingsLink />
                    </Container>
                </NavItem>
                <NavItem displayFrom="sm">
                    <GuestBecomeSellerNavItem />
                </NavItem>
                <NavDivider displayFrom="sm" />
                <NavItem displayFrom="sm">
                    <LoginLink />
                </NavItem>
                <NavItem>
                    <JoinLink />
                </NavItem>
            </Nav>
        </Layout>
    );
};

export default withContext(LoggedOutHomepage);
